<template>
  <div class="p-tabs">
    <div class="d-flex tabs-container">
      <span
        v-for="(option, index) in options"
        :key="index"
        class="tab-text-item"
        @click="onTabTextItemClicked(option, index)"
      >
        {{ option }}
      </span>
    </div>

    <div
      class="glider"
      :style="gliderStyle"
    />
  </div>
</template>

<script>
export default {
  name: 'PTabs',
  props: {
    options: {
      type: Array,
      default: () => []
    },
    value: {
      type: [String, Number, Object],
      default: null
    }
  },
  data: () => ({
    internalValue: null,
    currentIndex: 0
  }),
  computed: {
    /** The highlight sits over one option, whatever the number of options or the width. */
    gliderStyle () {
      const count = this.options.length || 1

      return {
        width: `calc((100% - 7px) / ${count})`,
        transform: `translateX(${this.currentIndex * 100}%)`
      }
    }
  },
  watch: {
    value: {
      immediate: true,
      handler (val) {
        this.internalValue = val

        // Follow a selection made from outside, so the highlight starts in the right place.
        const index = this.options.indexOf(val)
        if (index !== -1) this.currentIndex = index
      }
    },
    internalValue: {
      immediate: true,
      handler (val, oldVal) {
        if (val !== oldVal) {
          this.$emit('input', val)
        }
      }
    }
  },
  methods: {
    onTabTextItemClicked (option, index) {
      this.internalValue = option
      this.currentIndex = index
    }
  }
}
</script>

<style lang="scss" scoped>
.p-tabs {
    position: relative;

    .tabs-container {
        padding: 3.5px;
        border-radius: 16px;
        background: #E3E2E2;
        border: 0.5px solid #E3E2E2;

        .tab-text-item {
            flex: 1 1 0;
            padding: 6.5px 8px;
            font: normal normal normal 14px/18px Arial;
            color: #000000;
            text-align: center;
            cursor: pointer;
            z-index: 2;
        }
    }

    .glider {
        position: absolute;
        top: 3.5px;
        left: 3.5px;
        height: calc(100% - 7px);
        background: #FFFFFF;
        border-radius: 15px;
        transition: 0.25s ease-out;
    }
}
</style>
